import {BrandAPI} from "./BrandAPI";
import AvastConfig from "../../config/AvastConfig";

class AvastBrand extends BrandAPI {
    static get config() {
        return AvastConfig;
    }
}

export {AvastBrand};
